import React from 'react';
import styled from 'styled-components';

import { withLocalePrefix } from 'shared/utils/translation';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/utils/string'. 'app/webpack/javascripts/shared/utils/string.js' implicitly has an 'any' type.
import { toSentence } from 'shared/utils/string';

const t = withLocalePrefix('gdpr');
const MAX_WIDTH = 165;

type Props = {
  names: Array<string>;
};

export default function Names(props: Props) {
  const { names } = props;

  if (!names.length) {
    return null;
  }

  return (
    <StyledSpan>
      {names.length === 1 && <span>{names[0]}</span>}
      {names.length > 1 && allNamesAsComponent(names)}
    </StyledSpan>
  );
}

export function displayString(names: Array<string>) {
  switch (names.length) {
    case 0:
      return '';
    case 1:
      return names[0];
    default:
      return allNamesAsString(names);
  }
}

function allNamesAsComponent(names: Array<string>) {
  const [shown, hidden] = shownAndHiddenNames(names),
    count = names.length;

  if (shown.length < count) {
    return allNamesShortenedAsComponent(count, shown, hidden);
  }

  return <span>{toSentence(names)}</span>;
}

function allNamesAsString(names: Array<string>) {
  const [shown] = shownAndHiddenNames(names),
    count = names.length;

  if (shown.length < count) {
    return allNamesShortenedAsString(count, shown);
  }

  return toSentence(shown);
}

function shownAndHiddenNames(names: Array<string>) {
  const shown: Array<any | string> = [],
    hidden: Array<any | string> = [],
    baseLength = t('and_x_others', { count: 1 }).length;

  let width = 0;

  for (let i = 0; i < names.length; i++) {
    const name = names[i];

    if (width + name.length + baseLength >= MAX_WIDTH) {
      hidden.push(name);
      continue;
    }

    width += name.length + 2; // name and ", "
    shown.push(name);
  }

  return [shown, hidden];
}

function allNamesShortenedAsComponent(
  count: number,
  shown: Array<any | string>,
  hidden: Array<any | string>
) {
  const text = additionalText(count, shown.length);

  return (
    <span>
      {shown.join(', ')},{' '}
      <RevealableText alternateText={toSentence(hidden)} text={text} />
    </span>
  );
}

function allNamesShortenedAsString(count: number, shown: Array<any | string>) {
  const text = additionalText(count, shown.length);

  return `${shown.join(', ')}, ${text}`;
}

function additionalText(all: number, shown: number) {
  if (all - shown === 1) {
    return t('and_1_other');
  } else {
    return t('and_x_others', { count: all - shown });
  }
}

// =========================================================

type RTProps = {
  alternateText: string;
  text: string;
};

type State = {
  showText: boolean;
};

class RevealableText extends React.Component<RTProps, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      showText: false,
    };
  }

  render() {
    if (this.state.showText) {
      return this.renderAlternateText();
    } else {
      return this.renderShortText();
    }
  }

  renderAlternateText() {
    return (
      <span>
        {this.props.alternateText}
        <div>
          <Link onClick={this.toggle}>{t('show_less')}</Link>
        </div>
      </span>
    );
  }

  renderShortText() {
    return (
      <span>
        <Link onClick={this.toggle}>{this.props.text}</Link>
      </span>
    );
  }

  toggle = () => {
    this.setState((prevState) => ({ showText: !prevState.showText }));
  };
}

const StyledSpan = styled.span`
  word-break: break-word;
`;

const Link = styled.a`
  display: inline-block;
  cursor: pointer;
`;

export { Link };
